import PropTypes from 'prop-types';
import React from 'react';

import { ReactComponent as SVG } from './notfound.svg';

const NotFoundIcon = React.memo(({ fontSize, size }) => (
  <div
    style={{
      background: '#000000',
      borderRadius: '50%',
      color: '#FF422F',
      fontSize,
      height: size,
      left: '-50%',
      lineHeight: 1.6,
      marginLeft: -10,
      marginTop: -10,
      position: 'absolute',
      textAlign: 'center',
      top: '-50%',
      verticalAlign: 'middle',
      width: size,
    }}>
    <SVG />
  </div>
));

NotFoundIcon.defaultProps = {
  fontSize: 22,
  size: 28,
};

NotFoundIcon.propTypes = {
  fontSize: PropTypes.number,
  size: PropTypes.number,
};

export default NotFoundIcon;
